import type { UnitSystemPreferences } from "types/Common";

export type UnitSystemPreferenceValues = {
  weightUnit: "kg" | "lbs";
  dimensionUnit: "cm" | "inch";
};

export function getUnitSystemPreferences(permissionsJson?: string | null): UnitSystemPreferenceValues {
  try {
    const parsed = JSON.parse(permissionsJson || "{}");
    const pref = parsed.unit_system_preferences as UnitSystemPreferences | undefined;
    const isInchLbs = pref === "inch-lbs";
    return {
      weightUnit: isInchLbs ? "lbs" : "kg",
      dimensionUnit: isInchLbs ? "inch" : "cm",
    };
  } catch {
    return { weightUnit: "kg", dimensionUnit: "cm" };
  }
}
